import axios from 'axios';

import type { GetApiV1IssuesData, GetApiV1IssuesProjectsResponse, GetApiV1IssuesResponse } from '~/api/generated';

type IssueFilters = NonNullable<GetApiV1IssuesData['query']>;

export async function fetchIssues(params: IssueFilters = {}): Promise<GetApiV1IssuesResponse> {
  const { data } = await axios.get<GetApiV1IssuesResponse>('/api/v1/issues', { params });

  return data;
}

export async function fetchProjects(): Promise<GetApiV1IssuesProjectsResponse> {
  const { data } = await axios.get<GetApiV1IssuesProjectsResponse>('/api/v1/issues/projects');

  return data;
}
